import { render, staticRenderFns } from "./verifyCitizenID.vue?vue&type=template&id=9972fdb6"
import script from "./verifyCitizenID.vue?vue&type=script&lang=js"
export * from "./verifyCitizenID.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports